import { WebApiService } from '../../../../../plugins/webApiService'
import { Events } from '../../../../../plugins/events'
import { SendRequestModel } from '../../../../../plugins/models/SendRequestModel'
import WsResponseModelT from '../../../../../schema-builder/server/models/WsResponseModelT';
import ModelPersonTemplate from '../../../../../i-public-service/aba-finance/models/ModelPersonTemplate';

export default class PaymentsWsController {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	GetTemplatesEvent = new Events<WsResponseModelT<Array<ModelPersonTemplate>>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('PaymentsWsController', 'GetTemplates', 'Main', (res: WsResponseModelT<Array<ModelPersonTemplate>>) => {
			self.GetTemplatesEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	async GetTemplates() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'PaymentsWsController',
			Method: 'GetTemplates',
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	async getTemplatesAsync(): Promise<Array<ModelPersonTemplate>> {
		return new Promise<Array<ModelPersonTemplate>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'PaymentsWsController',
				Method: 'GetTemplates',
				Callback: (response: WsResponseModelT<Array<ModelPersonTemplate>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ModelPersonTemplate>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}